// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoomContact
 */
export interface RoomContact {
    /**
     * Contact person name
     */
    name?: string;
    /**
     * Contact email address
     */
    email?: string;
    /**
     * Additional contact details
     */
    details?: string;
}

/**
 * Check if a given object implements the RoomContact interface.
 */
export function instanceOfRoomContact(value: object): value is RoomContact {
    return true;
}

export function RoomContactFromJSON(json: any): RoomContact {
    return RoomContactFromJSONTyped(json, false);
}

export function RoomContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoomContact {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'email': json['email'] == null ? undefined : json['email'],
        'details': json['details'] == null ? undefined : json['details'],
    };
}

export function RoomContactToJSON(json: any): RoomContact {
    return RoomContactToJSONTyped(json, false);
}

export function RoomContactToJSONTyped(value?: RoomContact | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'email': value['email'],
        'details': value['details'],
    };
}

